"use client";

import { PromoSlot } from "@/features/promo-slots/PromoSlot";
import type { ResolvedPromoSlot } from "@/features/promo-slots/types";

export interface PromoSectionProps {
    promo: ResolvedPromoSlot;
}

/**
 * PromoSection — Renders a single promotional content section suitable for inline placement
 * in a homepage mixed content stream.
 *
 * This is a thin named wrapper around {@link PromoSlot} under the shared `parts/` contract
 * so that non-news-blog variants (e.g. BasicHomepage) can consume it without coupling to
 * the features/promo-slots internals.
 */
export function PromoSection({ promo }: PromoSectionProps) {
    return <PromoSlot row={[promo]} />;
}
